// Where the dark/light choice is persisted. The choice is remembered across
// visits; there is no OS prefers-color-scheme fallback — first visit is always
// light (see docs/references/colour-palette.md).
const STORAGE_KEY = "stridy-theme";

// localStorage can throw (private mode, storage disabled), so both helpers are
// guarded and degrade to "light" / no-op rather than breaking app startup.
export function readStoredThemeIsDark() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark";
  } catch (e) {
    return false;
  }
}

export function storeThemeIsDark(isDark) {
  try {
    localStorage.setItem(STORAGE_KEY, isDark ? "dark" : "light");
  } catch (e) {
    // ignore — persistence is best-effort
  }
}
